import { render, staticRenderFns } from "./teacher_study_material.vue?vue&type=template&id=a0134934&"
import script from "./teacher_study_material.vue?vue&type=script&lang=js&"
export * from "./teacher_study_material.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports